import { graphql } from "../../../services/wp.api.service";

const query = `
query FacilitatorAccountQuery($facilitatorId: Int!) {
	facilitatorBy(facilitatorId: $facilitatorId) {
	  contactInformation {
		addressline1
		addressline2
		cellphone
		city
		companyname
		facilitatorCredentials
		facilitatortitle
		fieldGroupName
		homephone
		profileUrl
		state
		workphone
		zip
	  }
	}
}
`;

/**
 * Get my facilitator account
 * @param {func} useQuery
 * @param {int} facilitatorId
 * @param {object} options
 *
 * @returns
 */
export const getMyFacilitatorAccount = (useQuery, facilitatorId, options) => useQuery(
	["my_facilitator_account"],
	() => graphql({
		query,
		variables: {
			facilitatorId
		}
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return data.data.facilitatorBy.contactInformation;
		}),
	{
		staleTime: 1000 * 60 * 10,
		...options
	}
);
